import {Component, OnDestroy, OnInit} from '@angular/core';
import {DataStorageService} from '../../../data-storage.service';
import {ConfigService} from '../../../config.service';
import {Location} from '@angular/common';
import {ApiService} from '../../../api.service';
import {Router} from '@angular/router';
import {ApiOfferService} from '../../../apiServices/offer/api-offer.service';
import {ApiFollowUpService} from '../../../apiServices/followUp/api-follow-up.service';
import {ApiCustomerService} from '../../../apiServices/customer/api-customer.service';
import {ApiBagService} from '../../../apiServices/bag/api-bag.service';
import {AvailableComponents} from '../../../side-bar/enumAvailableComponents';

@Component({
  selector: 'app-follow-up',
  templateUrl: './follow-up.component.html',
  styleUrls: ['./follow-up.component.scss']
})
export class FollowUpComponent implements OnInit, OnDestroy {

  constructor(
    public dataStorageService: DataStorageService,
    private config: ConfigService,
    private api: ApiService,
    private bagApi: ApiBagService,
    private cuApi: ApiCustomerService,
    private oApi: ApiOfferService,
    private fuApi: ApiFollowUpService,
    private router: Router,
    private location: Location) {
  }

  ngOnInit() {
    this.dataStorageService.currentComponent = AvailableComponents.FollowUp;
    const element = document.getElementById('followUp');
    element.classList.add('active');
  }

  ngOnDestroy() {
    const element = document.getElementById('followUp');
    element.classList.remove('active');
  }


  editOffer() {
    this.oApi.getOfferOptions(this.dataStorageService.currentState.offerID)
      .then(() => {
        this.dataStorageService.sideBarAccordion.edit = true;
        this.router.navigate(['/customerProfile']); });
  }

  updateFollowUp() {
    this.fuApi.putFollowUp();
  }

  addFollowUp() {
    const date = new Date();
    const currentDate = date.getFullYear()
      + '-'
      + (date.getMonth() + 1)
      + '-'
      + date.getDate();
    const body = {
      'date': currentDate,
      'salesStage': this.dataStorageService.currentState.status !== 'OPEN' ? 'REOPENED' : 'CONTACTED',
      'nextStep': 'CONTACT',
      'nextDate': currentDate
    };
    this.fuApi.postFollowUp(body).then(response => {
      response.date = currentDate;
      response.nextDate = currentDate;
      this.dataStorageService.currentState.metaData.push(response);
      this.dataStorageService.currentState.status = 'OPEN';
    });
  }

  deleteClick() {
    this.oApi.deleteOffer(this.dataStorageService.currentState.offerID);
    this.dataStorageService.sideBarAccordion.edit = false;
    this.dataStorageService.sideBarAccordion.offer = true;
    this.router.navigate(['/myOffers']);
  }

  duplicateOffer() {
    const toDuplicateID = this.dataStorageService.currentState.offerID;
    this.oApi.getOfferOptions(toDuplicateID).then(() => {
      let duplicatedOffer;
      // create new offer
      this.oApi.postOfferDuplicate().then(response => {
        duplicatedOffer = response; // id and number is generated by server
        const newOfferID = duplicatedOffer.offerID; // easy access to offerID of duplicatedOffer
        // fill duplicatedOffer with fetched data
        duplicatedOffer.descriprionOfTheProject = this.dataStorageService.currentState.descriprionOfTheProject;
        duplicatedOffer.wishedSolution = this.dataStorageService.currentState.wishedSolution;
        duplicatedOffer.followupNotify = this.dataStorageService.currentState.followupNotify;
        this.oApi.putOfferOptions(duplicatedOffer);
        // customer data
        this.cuApi.getCustomer(toDuplicateID).then(() => {
          duplicatedOffer.customerProfile = this.dataStorageService.currentState.customerProfile;
          this.cuApi.putCustomer(newOfferID, duplicatedOffer.customerProfile).then(() => this.router.navigate(['/myOffers']));
        });

        // internet IPWORLDCOM
        this.api.getInternet(toDuplicateID, 'IPWORLDCOM').then(() => {
          const posts = [];
          this.dataStorageService.currentState.PPinternetIPworldcom.internet.forEach(value => {
            posts.push(this.api.postInternet(newOfferID, value));
          });
          Promise.all(posts).then(resolved => duplicatedOffer.PPinternetIPworldcom.internet.push(resolved));
        });

        // internet CYBERLINK
        this.api.getInternet(toDuplicateID, 'CYBERLINK').then(() => {
          const posts = [];
          this.dataStorageService.currentState.PPinternetCyberlink.internet.forEach(value => {
            posts.push(this.api.postInternet(newOfferID, value));
          });
          Promise.all(posts).then(resolved => duplicatedOffer.PPinternetCyberlink.internet.push(resolved));
        });

        // phone numbers to be ported
        this.api.getPortedNumbers(toDuplicateID).then(() => {
          const posts = [];
          this.dataStorageService.currentState.phoneNumbersToBePorted.range.forEach(range => {
            posts.push(this.api.postPortedNumbers(newOfferID, range));
          });
          Promise.all(posts).then(resolved => {
            duplicatedOffer.phoneNumbersToBePorted.range.push(resolved);
          });
        });

        // new numbers
        this.api.getNewNumbers(toDuplicateID).then(() => {
          const posts = [];
          this.dataStorageService.currentState.newPhoneNumber.range.forEach(value => {
            posts.push(this.api.postNewNumbers(newOfferID, value));
          });
          Promise.all(posts)
            .then(resolved => duplicatedOffer.newPhoneNumber.range.push(resolved));
        });
        // PP Hosted
        this.api.getPPHosted(toDuplicateID).then(() => {
          this.api.putPPHosted(newOfferID).then(() =>
            duplicatedOffer.PPhosted = this.dataStorageService.currentState.PPhosted);
        });
        // FR hosted
        this.api.getFRHosted(toDuplicateID).then(() => {
          this.api.putFRHosted(duplicatedOffer.offerID).then(() =>
            duplicatedOffer.businessFlatRateHosted = this.dataStorageService.currentState.businessFlatRateHosted);
        });
        // FR sip trunk
        this.api.getFRSipTrunk(toDuplicateID).then(() => {
          this.api.putFRSipTrunk(duplicatedOffer.offerID).then(() =>
            duplicatedOffer.businessFlatRateSipTrunk = this.dataStorageService.currentState.businessFlatRateSipTrunk);
        });
        // devices' bag
        this.bagApi.getBagDevice(toDuplicateID).then(() => {
          this.dataStorageService.currentState.deviceBag.forEach(item => {
            this.bagApi.putBagDevice(item.device.id, item.quantity, newOfferID);
          });
        });
      });
    });

  }


}



// WEBPACK FOOTER //
// ./src/app/content/my-offers/follow-up/follow-up.component.ts